import { render, staticRenderFns } from "./SessionsEdit.vue?vue&type=template&id=0bb469a6&"
import script from "./SessionsEdit.vue?vue&type=script&lang=js&"
export * from "./SessionsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports